<template>
  <div class="today-dashboard">

    <div class="dashboard-item">
      <div class="item-header">
        <div class="item-title">成品油</div>
      </div>
      <div class="item-main">
        <div class="item-amount">
          <countTo class="item-value"  :startVal="oldGasPower" :endVal="gasPower" :decimals="3"
                   separator=""/>
          <div class="item-unit">吨</div>
        </div>
      </div>
    </div>

    <div class="dashboard-item">
      <div class="item-header">
        <div class="item-title">天然气</div>
      </div>
      <div class="item-main">
        <div class="item-amount">
          <countTo class="item-value" :startVal="bydPower" :endVal="bydPower" :decimals="2" separator=""/>
          <div class="item-unit">方</div>
        </div>
      </div>
    </div>

    <div class="dashboard-item">
      <div class="item-header">
        <div class="item-title">LNG</div>
      </div>
      <div class="item-main">
        <div class="item-amount">
          <countTo class="item-value" :startVal="lngPower" :endVal="lngPower" :decimals="2" separator=""/>
          <div class="item-unit">方</div>
        </div>
      </div>
    </div>



    <div class="dashboard-item">
      <div class="item-header">
        <div class="item-title">电动汽车充电量</div>
      </div>
      <div class="item-main">
        <div class="item-amount">
          <countTo class="item-value" :startVal="oldPower" :endVal="power" :decimals="2"
                   separator=""/>
          <div class="item-unit">kwh</div>
        </div>
      </div>
    </div>



    <div class="dashboard-item">
      <div class="item-header">
        <div class="item-title">电动自行车充电</div>
      </div>
      <div class="item-main">
        <div class="item-amount">
          <countTo class="item-value" :startVal="oldBicyclePower" :endVal="bicyclePower" :decimals="2" separator=""/>
          <div class="item-unit">kwh</div>
        </div>
      </div>
    </div>

    <div class="dashboard-item">
      <div class="item-header">
        <div class="item-title">电动汽车换电量</div>
      </div>
      <div class="item-main">
        <div class="item-amount">
          <countTo class="item-value" :startVal="oldConverterPower" :endVal="converterPower" :decimals="2" separator=""/>
          <div class="item-unit">kwh</div>
        </div>
      </div>
    </div>



  </div>
</template>

<script>
import countTo from 'vue-count-to';

export default {
  components: { countTo },
  data() {
    return {
      dataList: [],
      oldPower: 0,
      power: 0,
      oldGasPower:0,
      gasPower:0,
      bicyclePower:0,
      oldBicyclePower:0,
      converterPower:0,
      oldConverterPower:0,
      lngPower:0,
      oldLngPower:0,
      bydPower:0,
      oldBydPower:0,
      gasDuration:1000,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.getData();
    });
  },
  methods: {
    async getData() {
      const today = this.$moment().format('YYYY-MM-DD');
      this.$api.getData_Power(today)
          .then(res => {
            if (this.power) {
              this.oldPower = this.power;
            }
            this.power = res.data.total_power;
          });

      this.$api.getData_GasPower(today)
          .then(res => {
            if (this.gasPower) {
              this.oldGasPower = this.gasPower;
            }
            this.gasPower = res.data.power;
          });

     this.$api.getBicycleChargingOrderStatisticsByDate(today)
      .then(res => {
        if (this.bicyclePower) {
          this.oldBicyclePower = this.bicyclePower;
        }
        this.bicyclePower = res.data.total_power;
      });

      const converterDate = new Date();
      const formattedToday = converterDate.toISOString().split('T')[0];
      const tenDaysAgo = new Date();
      tenDaysAgo.setDate(tenDaysAgo.getDate() - 10);
      const formattedTenDaysAgo = tenDaysAgo.toISOString().split('T')[0];

      this.$api.getConverterPowerByDateRange({begin: formattedTenDaysAgo,end: formattedToday}).then(res=>{
        if(res.succeed && res.data){
          if (this.converterPower) {
            this.oldConverterPower = this.converterPower;
          }
          this.converterPower = res.data[res.data.length - 1].converter_amount;
        }
      })

      await this.$api.getGas_LNG_CNG_Today().then(res=>{
             const dataList = res.data;
             this.lngPower = this.conversionLNG(dataList[0].xl, false, 2);
       })

       //气站今日数据
      await this.$api.getNatureGasTodayAmount().then(res=>{
         this.bydPower = res.data.data;
      });


    },
  },
};
</script>

<style scoped lang="scss">

.today-dashboard {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  .dashboard-item {
    width: 30%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 170px;
    margin-bottom: 15px;
    box-sizing: border-box;
    padding: 15px 30px;
    margin-left: 10px;
    border: solid 2px #B5D9F0;
    box-shadow: 0 0 20px rgba(255, 255, 255, .6) inset, 0 0 20px rgba(49, 146, 231, 0.8);

    &:nth-of-type(3n) {
      margin-right: 0;
    }

    &:nth-of-type(3), &:nth-of-type(4) {
      margin-bottom: 0;
    }

    .item-header {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }

    .item-title {
      font-size: 48px;
      font-family: "screen", serif;
      color: #E7F3FF;
      text-shadow: 0 0 1em rgba(82, 163, 255, 0.56), 0 0 1em rgba(82, 163, 255, 0.56);
      box-sizing: border-box;
    }

    .item-sub-title {
      font-size: 26px;
      color: rgba(154, 211, 226, 1);
    }

    .item-main {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .item-amount {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: flex-end;

      .item-value {
        font-size: 50px;
        color: #0CC874;
        font-family: "screen", serif;
        line-height: 80px;
      }

      .item-unit {
        font-size: 25px;
        font-weight: bold;
        color: rgba(181, 228, 255, .6);
        margin-left: 15px;
        line-height: 70px;
      }
    }

    .item-quantity {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: flex-end;

      .item-value {
        font-size: 36px;
        font-weight: bold;
        color: #0CC874;
        font-family: "Arial", serif;
        line-height: 80px;
      }

      .item-unit {
        font-size: 25px;
        font-weight: bold;
        color: rgba(181, 228, 255, .6);
        margin-left: 10px;
        line-height: 70px;
      }
    }
  }
}
</style>
